module.exports = __webpack_public_path__ + "img/sintesis.516810a1.svg";